module.exports = __webpack_public_path__ + "img/td.908f99d4.svg";